import React, { Component, useState } from "react";
import styles from "./css/HomeBeautyServices.module.css";

const beauty_services = [
  {
    bgColor: "#F0FBF4",
    title: "Hair Stylists",
    description: "Find and compare hair stylists you can trust.",
    icon: "/assets/icons/home-beauty-services/Hair Stylists.svg",
  },
  {
    bgColor: "#EDF7FA",
    title: "Nails",
    description:
      "Find professional nail technicians that fit in your schedule.",
    icon: "/assets/icons/home-beauty-services/Nails.svg",
  },
  {
    bgColor: "#F4FAEA",
    title: "Massage",
    description: "Bring spa-quality massage therapists directly to you.",
    icon: "/assets/icons/home-beauty-services/massage 1.svg",
  },
  {
    bgColor: "#F0FCFA",
    title: "Makeup",
    description:
      "Big date or big day, the perfect makeup artist is just around the corner.",
    icon: "/assets/icons/home-beauty-services/Makeup.svg",
  },
];

export class HomeBeautyServices extends Component {
  render() {
    return (
      <div className={styles.propertyManagmentDutiescomp}>
        <div className={styles.propertyManagmentDutiescompInner}>
          <div className={styles.topHeading}>
            <div className={styles.headingCont}>
              <h2>In-Home Beauty Services</h2>
            </div>
            <div className={styles.descriptionCont}>
              <p>
                Let our professional beauticians bring the luxury spa to you!
                Relax in the comfort of your home. Hair, nails, massages, and
                more are just a click away. Skip the traffic, parking, and
                waiting areas. Make your vacation even better by scheduling a
                quick massage, last minute nail color change, or a full face for
                a night out on the town.
              </p>
            </div>
          </div>

          <div className={styles.coverImageCont}>
            <div
              className={styles.coverImage}
            >
              <img src="/assets/img/woman-beauty-clinic-face-treatment.jpg" />

              <div className={styles.dutiesList}>
              <div className={styles.dutiesListInner}>
                {beauty_services.map((spec, index) => (
                  <SpecBlocks key={index} spec={spec}></SpecBlocks>
                ))}
              </div>
            </div>
            </div>

            
          </div>
        </div>
      </div>
    );
  }
}

const SpecBlocks = (props) => {
  const [spec, setSpec] = useState(props.spec);
  return (
    <div className={styles.specBlock}>
      <div className={styles.specBlockInner}>
        <div
          className={styles.iconCont}
          style={{ backgroundColor: spec["bgColor"] }}
        >
          <img src={spec["icon"]} />
        </div>
        <div className={styles.title}>
          <p>{spec["title"]}</p>
        </div>
        <div className={styles.description}>
          <p>{spec["description"]}</p>
        </div>
      </div>
    </div>
  );
};

export default HomeBeautyServices;
